import UtilService from "./UtilService";
import UtilServiceReact from "./UtilServiceReact";
import { isIOS, isMacOs, isAndroid, isMobile as isMobileDevice } from 'react-device-detect';

const WindowService = () => {
    const utilServiceReact = UtilServiceReact();

    // Listen for messages from the React Native side
    window.addEventListener('message', event => {
        // Parse the event data from the message
        let messageData;

        try {
            messageData = JSON.parse(event.data);
        } catch (e) {
            return;
        }

        // Check if the message is the location response
        if (messageData.type === 'requestLocationCoordinates') {
            localStorage.setItem('requestLocationCoordinates', JSON.stringify(messageData.data));
            // Handle the 'denied' status
            if (messageData.data.status === 'denied') {
                UtilService.setLocalStorageLocationPermission('denied');
            } else {
                // Store the received coordinates in localStorage
                UtilService.setLocalStorageLocationPermission(messageData.data);
            }
        }

        // Check if the message is the location response
        if (messageData.type === 'requestLocationPermissions') {
            localStorage.setItem('requestLocationPermissions', JSON.stringify(messageData.data));
            // Handle the 'denied' status
            if (messageData.data.status === 'denied') {
                UtilService.setLocalStorageLocationPermission('denied');
            } else {
                // Store the received coordinates in localStorage
                UtilService.setLocalStorageLocationPermission(messageData.data);
            }
        }

        if (messageData.type === 'requestOriginURL') {
            localStorage.setItem('requestOriginURL', JSON.stringify(messageData.data));
        }

        if (messageData.type === 'requestStartRecordingMicrophonePermissions') {
            if (messageData.data.status === 'denied') {
                localStorage.setItem('requestStartRecordingMicrophonePermissions', 'denied');
            } else {
                // Store the received coordinates in localStorage
                localStorage.setItem('requestStartRecordingMicrophonePermissions', messageData.data);
            }
        }

        // Handle PDF download results
        if (messageData.type === 'downloadFileResult') {
            console.log('PDF download result:', messageData.data);
            if (messageData.data.success) {
                utilServiceReact.showSuccessTimerAlert("PDF Downloaded", messageData.data.message || "File downloaded successfully");
            } else {
                utilServiceReact.showWarningTimerAlert("Download Failed", messageData.data.message || "Failed to download PDF");
            }
        }

        // Handle PDF preview results
        if (messageData.type === 'previewPdfResult') {
            console.log('PDF preview result:', messageData.data);
            if (messageData.data.success) {
                utilServiceReact.showSuccessTimerAlert("PDF Preview", messageData.data.message || "PDF opened in native viewer");
            } else {
                // Handle preview failure - try web fallback for iOS
                console.log('Native preview failed, attempting web fallback for iOS...');
                if (isIOS && messageData.data.url) {
                    // Try web preview as fallback
                    try {
                        window.open(messageData.data.url, '_blank');
                        utilServiceReact.showSuccessTimerAlert("PDF Preview", "PDF opened in browser (fallback)");
                    } catch (error) {
                        utilServiceReact.showWarningTimerAlert("Preview Failed", "Unable to preview PDF. Please download instead.");
                    }
                } else {
                    utilServiceReact.showWarningTimerAlert("Preview Failed", messageData.data.message || "Unable to preview PDF");
                }
            }
        }

        // Handle PDF download and preview results
        if (messageData.type === 'downloadAndPreviewPdfResult') {
            console.log('PDF download and preview result:', messageData.data);
            if (messageData.data.success) {
                utilServiceReact.showSuccessTimerAlert("PDF Ready", "PDF downloaded and ready for preview");
            }
        }

        // Handle PDF quick share results
        if (messageData.type === 'quickSharePdfResult') {
            console.log('PDF quick share result:', messageData.data);
            if (messageData.data.success) {
                utilServiceReact.showSuccessTimerAlert("PDF Shared", "PDF shared successfully");
            }
        }

        // Handle push notification results
        if (messageData.type === 'sendPushNotificationResult') {
            console.log('Push notification result:', messageData.data);
            if (messageData.data.success) {
                utilServiceReact.showSuccessTimerAlert("Notification Sent", messageData.data.message || "Push notification sent successfully");
            }
        }

        // Handle user registration update results
        if (messageData.type === 'userRegistrationUpdated') {
            console.log('User registration update result:', messageData.data);
            if (messageData.data.success) {
                utilServiceReact.showSuccessTimerAlert("Registration Updated", messageData.data.message || "User registration updated successfully");
            }
        }

        // Handle mobile capabilities detection
        if (messageData.type === 'mobileCapabilitiesDetected') {
            console.log('Mobile capabilities detected:', messageData.data);
            localStorage.setItem('mobileCapabilities', JSON.stringify(messageData.data));
        }
    });

    const sendMessageRequestReview = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage("requestReview");
        } else {
            console.log('Not inside React Native WebView');
        }
    };

    const sendMessageReloadApp = () => {
        utilServiceReact.showSuccessTimerAlert("Loading", "Checking for updates...");

        setTimeout(() => {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage("reloadApp");
                utilServiceReact.showSuccessTimerAlert("Success", "App reloaded. You are now running the latest version!");
            } else {
                window.location.reload();
                utilServiceReact.showWarningTimerAlert("Notice", "Reloaded. Please ensure you're running the latest version by checking updates manually.");
            }
        }, 3000);
    };


    const sendMessageRequestImagePickerPermissions = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage("requestImagePickerPermissions");
        } else {
            console.log('Not inside React Native WebView');
        }
    };

    const sendMessageRequestLocationPermissions = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage("requestLocationPermissions");
        }
    };

    const sendMessageRequestLocationCoordinatesPermissions = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage("requestLocationCoordinates");
        } else {
            console.log('Not inside React Native WebView');
        }
    };

    const sendMessageRequestStartRecordingMicrophonePermissions = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage("requestStartRecordingMicrophonePermissions");
        } else {
            console.log('Not inside React Native WebView');
        }
    };

    const sendMessageRequestStopRecordingMicrophonePermissions = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage("requestStopRecordingMicrophonePermissions");
        } else {
            console.log('Not inside React Native WebView');
        }
    };

    // Enhanced PDF functions for mobile WebView
    const sendMessageRequestDownloadPdf = (pdfUrl: string, fileName: string) => {
        if (window.ReactNativeWebView) {
            console.log('Mobile PDF download requested:', { pdfUrl, fileName });
            const messageData = {
                type: "requestDownloadFile",
                data: {
                    url: pdfUrl,
                    filename: fileName
                }
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
        } else {
            console.log('Not inside React Native WebView - PDF download would use web flow');
        }
    };

    const sendMessageRequestPreviewPdf = (pdfUrl: string, fileName: string) => {
        if (window.ReactNativeWebView) {
            console.log('Mobile PDF preview requested:', { pdfUrl, fileName });
            const messageData = {
                type: "requestPreviewPdf",
                data: {
                    url: pdfUrl,
                    filename: fileName
                }
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
        } else {
            console.log('Not inside React Native WebView - PDF preview would use web flow');
        }
    };

    const sendMessageRequestDownloadAndPreviewPdf = (pdfUrl: string, fileName: string) => {
        if (window.ReactNativeWebView) {
            console.log('Mobile PDF download and preview requested:', { pdfUrl, fileName });
            const messageData = {
                type: "requestDownloadAndPreviewPdf",
                data: {
                    url: pdfUrl,
                    filename: fileName
                }
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
        } else {
            console.log('Not inside React Native WebView - PDF download and preview would use web flow');
        }
    };

    const sendMessageRequestQuickSharePdf = (pdfUrl: string, fileName: string) => {
        if (window.ReactNativeWebView) {
            console.log('Mobile PDF quick share requested:', { pdfUrl, fileName });
            const messageData = {
                type: "requestQuickSharePdf",
                data: {
                    url: pdfUrl,
                    filename: fileName
                }
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
        } else {
            console.log('Not inside React Native WebView - PDF quick share would use web flow');
        }
    };

    // Mobile detection helper functions
    const isMobileWebView = (): boolean => {
        return !!(window as any).ReactNativeWebView && (isIOS || isAndroid);
    };

    const hasNativePdfSupport = (): boolean => {
        return isMobileWebView() && typeof (window as any).previewPdf === 'function';
    };

    const getMobileCapabilities = () => {
        return {
            isMobile: isMobileDevice,
            isWebView: !!(window as any).ReactNativeWebView,
            isMobileWebView: isMobileWebView(),
            hasNativePdfSupport: hasNativePdfSupport(),
            platform: isIOS ? 'ios' : isAndroid ? 'android' : 'web',
            deviceInfo: {
                isIOS,
                isMacOs,
                isAndroid,
                isMobileDevice
            }
        };
    };

    const sendMessageRequestPushNotification = (title: string, body: string, data?: any) => {
        if (window.ReactNativeWebView) {
            console.log('Mobile push notification requested:', { title, body, data });
            const messageData = {
                type: "requestSendPushNotification",
                data: {
                    title,
                    body,
                    data: data || {}
                }
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
        } else {
            console.log('Not inside React Native WebView - push notification would use web flow');
        }
    };



    return {
        sendMessageRequestReview,
        sendMessageReloadApp,
        sendMessageRequestImagePickerPermissions,
        sendMessageRequestLocationPermissions,
        sendMessageRequestStartRecordingMicrophonePermissions,
        sendMessageRequestStopRecordingMicrophonePermissions,
        sendMessageRequestLocationCoordinatesPermissions,
        sendMessageRequestDownloadPdf,
        sendMessageRequestPreviewPdf,
        sendMessageRequestDownloadAndPreviewPdf,
        sendMessageRequestQuickSharePdf,
        sendMessageRequestPushNotification,
        isMobileWebView,
        hasNativePdfSupport,
        getMobileCapabilities,
    };
}

export default WindowService;
